import { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { ReactComponent as ArrowDown } from '../../../assets/images/common/icons/arrowDown.svg'

import classes from './FiltersPopover.module.scss'

const CollapsibleFilterSection = ({ title, defaultOpen = true, children }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <div className={classes.filterSection}>
      <button
        className={classes.sectionHeader}
        onClick={() => setIsOpen(prev => !prev)}
      >
        <span className={classes.sectionTitle}>{title}</span>
        <ArrowDown
          width={14}
          height={14}
          className={classNames(classes.sectionArrow, { [classes.sectionArrowUp]: isOpen })}
        />
      </button>
      {isOpen && <div className={classes.sectionContent}>{children}</div>}
      <hr className={classes.sectionDivider} />
    </div>
  )
}

CollapsibleFilterSection.propTypes = {
  title: PropTypes.string.isRequired,
  defaultOpen: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default CollapsibleFilterSection
